import { Observable } from 'rxjs'
import { License } from '../models/license-details'
import { LicenseStatus } from '../models/license-status'
import { AppointmentStatus } from '../models/appointment-status'
import { ValidatedSelectOptionModel as State } from '../../validations/validated-dropdown.component'
import { ContentManagementDetail } from '../../content-management/models/content-mgt-detail'
import { OrgSettingsModel } from '../../org-management/models/org-settings-model'

export abstract class LicenseApptGateway {
    abstract getUserLicenseDetails(userProfileID: number): Observable<License[]>
    abstract deleteLicense(licenseID: number, UserProfileID: number): Observable<License[]>
    abstract saveLicense(license: License): Observable<License[]>
    abstract editLicense(license: License): Observable<License[]>
    abstract getAllStates(userProfileID: number): Observable<State[]>
    abstract getUserStatesForLicense(): Observable<State[]>
    abstract getAllLicenseStatus(): Observable<LicenseStatus[]>
    abstract updateStatusofLicense(license: License): Observable<License[]>
    abstract getAllAppointment(): Observable<AppointmentStatus[]>
    abstract addAppointment(license: License): Observable<License[]>
    abstract getExpireLicense(userProfileID: number): Observable<License[]>
    abstract getUserLicenseDetailsForEnrollment(userProfileName: string): Observable<State[]>
    abstract getContentDetails(parentshortname: string, sectionshortname: string): Observable<ContentManagementDetail[]>
    abstract getFMOSettings(orgId: string): Observable<OrgSettingsModel[]>

    abstract getUsersLicenseStates(userProfileName: string): Observable<State[]>
}
